export default "__VITE_ASSET__tjZSLraf__"